import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../../store/useAppStore';
import { useBakerActionsEnabled } from '../../../hooks/useBakerActionsEnabled';
import { useMutationFeedback } from '../../../hooks/useMutationFeedback';

function SmartJoinHint({ order, matches }) {
  const { t } = useTranslation();
  const enabled = useBakerActionsEnabled();
  const joinOrders = useAppStore((state) => state.joinOrders);
  const { run } = useMutationFeedback();

  const handleJoin = async (match) => {
    await run(() => joinOrders([order.id, match.order.id]), t('msg.joined'));
  };

  return (
    <div className="rounded-md border border-emerald-500/30 bg-emerald-500/10 px-4 py-3">
      {matches.length === 0 ? (
        <p className="text-sm theme-muted">{t('smartJoin.halfRequired')}</p>
      ) : (
        <div className="space-y-1">
          {matches.map((match) => (
            <button
              key={match.order.id}
              type="button"
              disabled={!enabled}
              onClick={() => handleJoin(match)}
              className="block text-sm theme-accent underline underline-offset-2 hover:opacity-80 disabled:opacity-30"
            >
              {t('smartJoin.joinWith', {
                customer: match.order.customerName,
                common: match.common,
                additional: match.additional,
              })}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default SmartJoinHint;
